import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { ContainerApplicationsComponent } from './applications/container-applications.component';
import { ContainerAttachmentsComponent } from './attachments/container-attachments.component';
import { ContainerAttachmentsService } from './attachments/container-attachments.service';
import { DirectivesModule } from '../common/directives.module';
import { FileDownloadDialog } from './file-download-dialog/file-download-dialog.component';
import { FileModule } from '../files/file.module';
import { MaterialModule } from '../material.module';
import { PipesModule } from '../shared/pipes.module';
import { ContainerNotes } from './notes/container-notes.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    DirectivesModule,
    FormsModule,
    FileModule,
    ReactiveFormsModule,
    MaterialModule,
    MatDialogModule,
    PipesModule,
    SharedModule,
  ],
  exports: [
    ContainerApplicationsComponent,
    ContainerAttachmentsComponent,
    ContainerNotes,
  ],
  declarations: [
    ContainerApplicationsComponent,
    ContainerAttachmentsComponent,
    ContainerNotes,
    FileDownloadDialog,
  ],
  providers: [
    ContainerAttachmentsService,
  ],
})
export class ContainerModule { }
